<template>
<div class="container">
<!-- <o-tabs :position="'left'" :size="'medium'" :type="'toggle'" vertical :expanded="'expanded'"> -->


  <div class="block">
      <div class="columns">
        <div v-if="template" class="column is-6">
          <!-- <div class="is-flex is-justify-content-space-between is-flex-wrap-wrap">
            <o-icon
              @click="$router.push({name: 'Domain', query: {'q': domain.name}})"
              icon="arrow-left" size="medium" clickable class="mr-4"></o-icon>
            <h1 class="title">{{ domain.name }}</h1>
          </div> -->

          <h1 class="title">
            <o-icon
              @click="$router.push({name: 'Domain', query: {'q': template.domain[0]}})"
              icon="arrow-left" size="medium" clickable class="mr-4"></o-icon>
              <span v-for="domain in template.domain">{{ domain }}</span>
          </h1>
          <h4 class="subtitle">Template ID: {{ template.id }}</h4>
        </div>
        <div class="column is-3">
            <o-field label="Department Details">
                <o-select placeholder="Select" v-if="domain" v-model="departmentId" @change="depChanged">
                    <optgroup label="Usign this template">
                      <option v-for="dep in departmentsUsignTemplate" :key="dep.id" :value="dep.id" >
                        {{dep.name}}
                      </option>
                    </optgroup>
                    <optgroup label="Other">
                      <option v-for="dep in departmentsNotUsignTemplate" :key="dep.id" :value="dep.id" >
                        {{dep.name}}
                      </option>
                    </optgroup>
                </o-select>
            </o-field>
        </div>
        <div class="column is-3">
          <o-field label="Viewing as:">
            <o-input
              type="text"
              v-model="userEmail"
              placeholder="email"
              @change="getUserDetails"
              required>
            </o-input>
          </o-field>
        </div>
      </div>
    </div>

    <o-tabs v-model="activeTab" :position="''" :size="'medium'" :type="'default'"  :expanded="'expanded'">
      <o-tab-item label="Template HTML editor" value="code">
            <div class="columns" v-if="template">
              <div class="column is-full">
                <!-- <div class="block">
                  <div class="columns">
                    <div class="column is-6">
                      <h1 class="title">Domain: <span v-for="domain in template.domain">{{ domain }}</span></h1>
                      <h4 class="subtitle">Template ID: {{ template.id }}</h4>
                    </div>
                    <div class="column is-3">
                        <o-field label="Department Details">
                            <o-select placeholder="Select" v-if="dom" v-model="departmentId" @change="depChanged">
                                <option v-for="dep in dom.departments" :key="dep.id" :value="dep.id" >{{dep.name}}</option>
                            </o-select>
                        </o-field>
                    </div>
                    <div class="column is-3">
                      <o-field label="Viewing as:">
                        <o-input
                          type="text"
                          v-model="userEmail"
                          placeholder="email"
                          @change="getUserDetails"
                          required>
                        </o-input>
                      </o-field>
                    </div>
                  </div>
                </div> -->
                <div class="block">
                  <o-field>
                    <o-slider :min="3" :max="30" ticks v-model="fontSize"></o-slider>
                  </o-field>
                </div>
                <v-ace-editor
                        v-model:value="template.content"
                        lang="html"
                        theme="monokai"
                        :options="{fontSize: fontSize + 'pt'}"
                        style="height: 500px; width: auto;"/>
                <hr/>
                <div class="block">
                  <div class="columns">
                    <div class="column is-8">
                      <div class="box signature-box">
                        <SignatureRender v-bind:html="templatePreview"></SignatureRender>
                      </div>
                    </div>
                    <div class="column is-4 ">
                      <div class="columns ">
                        <div class="column is-6 has-text-centered"><o-button variant="success" @click="getRenderedTemplate">Refresh</o-button></div>
                        <div class="column is-6 has-text-centered"><o-button variant="info" @click="saveTemplate">Save</o-button></div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
      </o-tab-item>

      <o-tab-item label="Example client data" value="data">
          <div class="columns">
            <div class="column is-6">
              <div class="box">
                  <h4 class="title is-4">Department Fields</h4>

                  <div v-if="departmentDetails">
                    <o-field :label="field.title + ' {' + field.key + '}' " v-for="field in departmentDetails.fields" :key="field.key">
                        <o-input :placeholder="field.placeholder" type="text" v-model="field.value" expanded></o-input>
                    </o-field>
                  </div>

                  <div v-else>
                    <h4 class="title is-6">Please select department</h4>
                  </div>
              </div>
            </div>

            <div class="column is-6">
              <div class="box">
                  <h4 class="title is-4">User Fields</h4>

                  <div v-if="userDetails">
                    <o-field :label="field.title + ' {' + field.key + '}' " v-for="field in userDetails.fields" :key="field.key">
                        <o-input :placeholder="field.placeholder" type="text" v-model="field.value" expanded></o-input>
                    </o-field>
                  </div>

                  <div v-else>
                    <h4 class="title is-6">Please specify user email</h4>
                  </div>
              </div>
            </div>

          </div>
      </o-tab-item>

    </o-tabs>

</div>
</template>

<script>
import axios from "axios";
import SignatureRender from '../components/SignatureRender';
import { VAceEditor } from 'vue3-ace-editor';

import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-monokai';

export default {
  name: "TemplateEditor",
  components: {
    SignatureRender,
    VAceEditor,
  },
  data() {
    return {
      activeTab: 'code',
      template: null,
      templatePreview: "",
      fontSize: 14,
      userEmail: '',
      domainDetails: {'email': 'xxx'},
      departmentId: null,
      departmentDetails: null,
      userDetails: null,
      domain: null,

    }
  },
  computed: {
    getFontSize(){
      return this.fontSize + 'px'
    },
    departmentsUsignTemplate(){
      return this.domain.departments.filter(dep => dep.template == this.template.id).sort((a,b)=>{
        const A = a.name.toUpperCase();
        const B = b.name.toUpperCase();
        return (A < B) ? -1 : (A > B) ? 1 : 0;
      })
    },
    departmentsNotUsignTemplate(){
      return this.domain.departments.filter(dep => dep.template != this.template.id).sort((a,b)=>{
        const A = a.name.toUpperCase();
        const B = b.name.toUpperCase();
        return (A < B) ? -1 : (A > B) ? 1 : 0;
      })
    }
  },
  methods: {
    getTemplate() {
      axios.get('/api/template/' + this.$route.params.id)
        .then(response => {
          this.template = response.data
          console.log(response.data);
          this.getRenderedTemplate();
          this.getDomain();
        })
        .catch(error => {
          this.$oruga.notification.open({
              message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
              rootClass: 'toast-notification-danger',
              position: 'top',
              duration: 3000
            })
          console.error(error);
        })
    },
    getRenderedTemplate(){
      const payload = {
        "sig_html": this.template.content,
        "email": this.userEmail.trim(),
        "department_details": this.departmentDetails,
        "user_details": this.userDetails,
        "domain_details": this.domainDetails,
        "domain_id": this.template.domain[0],
        "department_id": this.departmentId
      }
      axios.post('/api/template/render', payload)
        .then(response => {
          this.templatePreview = response.data
        })
    },
    saveTemplate(){
      axios.put('/api/template/' + this.$route.params.id, {"content": this.template.content})
        .then(response => {
          console.log(response);
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDomain() {
      const domain_name = this.template.domain[0];
      console.log(`Getting domain = ${domain_name}`)
      return axios.get('/api/domain/', {params: {'q': domain_name}})
          .then(response => {
              this.domain = response.data;
              this.userEmail = response.data.domain.admin;
              this.domain.departments.some(dep => {
                if (dep.template === this.template.id){
                  this.departmentId = dep.id;
                  return true
                }
              });
              this.getUserDetails();
              this.getDepartment();
              console.log(response.data);
          })
          .catch(error => {
              console.error(error);
          })
    },
    depChanged(){
        console.log(`Department has been selected just changed! to ${this.departmentId}`)
        this.getDepartment();
    },
    getDepartment(){
        return axios.get('/api/department/' + this.departmentId)
            .then(response => {
                console.log(response.data);
                this.departmentDetails = response.data;
                this.getRenderedTemplate();
            })
            .catch(error=>{
                console.log(error);
            })
    },
    getUserDetails(){
      return axios.get('/api/user/' + this.userEmail)
          .then(response => {
              console.log(response.data);
              this.userDetails = response.data;
              this.getRenderedTemplate();
          })
          .catch(error=>{
              console.log(error);
          })
    }
  },
  created() {
    this.getTemplate();

  }
};
</script>

<style>
textarea,
pre {
    -moz-tab-size : 1;
      -o-tab-size : 1;
         tab-size : 1;
}
.box.signature-box{
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 67%), 0 0px 0 1px rgb(10 10 10 / 39%);
}
</style>
